// Generated by CoffeeScript 2.7.0
var SettingsContainer;

import SettingsTab from 'trunks/vue/admin/components/settings/settings_tab.js';

export default SettingsContainer = Vue.extend({
  components: {
    'settings-tab': SettingsTab
  },
  props: {
    activeTab: {
      type: String
    }
  },
  computed: {
    showTabNav: function() {
      var tabs;
      tabs = Skylark.Helpers.translate('settings.namespace_settings_tab');
      return Object.keys(tabs).some((key) => {
        return key.replace('settings__', '') === this.activeTab;
      });
    }
  },
  template: `<div class="main-content-wrapper">
  <settings-tab v-if="showTabNav" :activeTab="activeTab" />
  <div class="settings-wrapper">
    <slot name="content"></slot>
  </div>
</div>`
});
